var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Button',_vm._b({attrs:{"loading":_vm.isAuthorizing},on:{"click":_vm.authorize}},'Button',_vm.$attrs,false),[_vm._t("default",function(){return [_vm._v("Authorize")]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }